import { render } from "./ExpiredModal.vue?vue&type=template&id=60d669a6&scoped=true"
import script from "./ExpiredModal.vue?vue&type=script&lang=js"
export * from "./ExpiredModal.vue?vue&type=script&lang=js"

import "./ExpiredModal.vue?vue&type=style&index=0&id=60d669a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60d669a6"

export default script